import React, { useState } from 'react';

const TemplateModal = ({ isOpen, onClose, showSuccess }) => {
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const templates = [
        {
            id: 1,
            name: 'ID Corporativo',
            icon: '🏢',
            color: 'bg-blue-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#f8fafc', selectable: false, evented: false },
                { type: 'rect', left: 0, top: 0, width: 640, height: 80, fill: '#1e3a8a', selectable: false },
                { type: 'text', left: 30, top: 25, text: 'CORPORATE NAME', fontSize: 24, fontWeight: 'bold', fill: '#ffffff', fontFamily: 'Arial' },
                { type: 'rect', left: 30, top: 100, width: 150, height: 180, fill: '#e2e8f0', stroke: '#cbd5e1', strokeWidth: 2 },
                { type: 'text', left: 65, top: 170, text: 'PHOTO', fontSize: 20, fill: '#94a3b8', fontFamily: 'Arial' },
                { type: 'text', left: 200, top: 120, text: 'EMPLOYEE NAME', fontSize: 28, fontWeight: 'bold', fill: '#0f172a', fontFamily: 'Arial' },
                { type: 'text', left: 200, top: 160, text: 'Software Engineer', fontSize: 18, fill: '#475569', fontFamily: 'Arial' },
                { type: 'text', left: 200, top: 200, text: 'ID: 8849201', fontSize: 16, fill: '#64748b', fontFamily: 'Arial' },
                { type: 'rect', left: 0, top: 360, width: 640, height: 40, fill: '#1e3a8a', selectable: false }
            ]
        },
        {
            id: 2,
            name: 'Tarjeta de Acceso',
            icon: '🔑',
            color: 'bg-green-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#111827', selectable: false, evented: false },
                { type: 'rect', left: 20, top: 20, width: 600, height: 360, fill: 'transparent', stroke: '#10b981', strokeWidth: 4, rx: 20, ry: 20 },
                { type: 'text', left: 50, top: 50, text: 'ACCESS PASS', fontSize: 40, fontWeight: 'bold', fill: '#10b981', fontFamily: 'Arial' },
                { type: 'text', left: 50, top: 120, text: 'LEVEL 5', fontSize: 80, fontWeight: 'bold', fill: '#ffffff', fontFamily: 'Arial' },
                { type: 'text', left: 50, top: 300, text: 'AUTHORIZED PERSONNEL', fontSize: 20, fill: '#9ca3af', fontFamily: 'Arial' },
                { type: 'rect', left: 450, top: 50, width: 140, height: 140, fill: '#ffffff' },
                { type: 'text', left: 485, top: 110, text: 'QR', fontSize: 40, fill: '#000000' }
            ]
        },
        {
            id: 3,
            name: 'Membresía VIP',
            icon: '👑',
            color: 'bg-yellow-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#000000', selectable: false, evented: false },
                { type: 'rect', left: 0, top: 150, width: 640, height: 2, fill: '#fbbf24' },
                { type: 'text', left: 320, top: 60, text: 'VIP MEMBER', fontSize: 48, fontWeight: 'bold', fill: '#fbbf24', fontFamily: 'Times New Roman', originX: 'center' },
                { type: 'text', left: 320, top: 200, text: 'JONATHAN DOE', fontSize: 32, fontWeight: 'bold', fill: '#ffffff', fontFamily: 'Arial', originX: 'center' },
                { type: 'text', left: 320, top: 250, text: '0000 1111 2222 3333', fontSize: 24, fill: '#fbbf24', fontFamily: 'Courier New', originX: 'center', letterSpacing: 100 },
                { type: 'text', left: 50, top: 340, text: 'VALID THRU: 12/28', fontSize: 16, fill: '#fbbf24', fontFamily: 'Arial' },
                { type: 'text', left: 450, top: 340, text: 'PLATINUM STATUS', fontSize: 16, fill: '#fbbf24', fontFamily: 'Arial' }
            ]
        },
        {
            id: 4,
            name: 'Visitante',
            icon: '👋',
            color: 'bg-purple-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#ffffff', selectable: false, evented: false },
                { type: 'rect', left: 0, top: 0, width: 640, height: 120, fill: '#ef4444', selectable: false },
                { type: 'text', left: 320, top: 35, text: 'VISITOR', fontSize: 60, fontWeight: 'bold', fill: '#ffffff', fontFamily: 'Arial', originX: 'center' },
                { type: 'text', left: 320, top: 180, text: 'PLEASE RETURN', fontSize: 30, fontWeight: 'bold', fill: '#000000', fontFamily: 'Arial', originX: 'center' },
                { type: 'text', left: 320, top: 230, text: 'TO RECEPTION', fontSize: 30, fontWeight: 'bold', fill: '#000000', fontFamily: 'Arial', originX: 'center' },
                { type: 'text', left: 320, top: 320, text: 'DATE: ________________', fontSize: 20, fill: '#666666', fontFamily: 'Arial', originX: 'center' }
            ]
        },
        {
            id: 5,
            name: 'Estudiante',
            icon: '🎓',
            color: 'bg-red-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#ffffff', selectable: false, evented: false },
                { type: 'rect', left: 0, top: 0, width: 150, height: 400, fill: '#dc2626', selectable: false },
                { type: 'circle', left: 75, top: 80, radius: 50, fill: '#ffffff', originX: 'center', originY: 'center' },
                { type: 'text', left: 75, top: 70, text: 'LOGO', fontSize: 14, fill: '#dc2626', originX: 'center', originY: 'center', fontWeight: 'bold' },
                { type: 'text', left: 200, top: 50, text: 'HIGH SCHOOL', fontSize: 32, fontWeight: 'bold', fill: '#dc2626', fontFamily: 'Arial' },
                { type: 'text', left: 200, top: 100, text: 'STUDENT ID', fontSize: 24, fill: '#000000', fontFamily: 'Arial' },
                { type: 'rect', left: 200, top: 150, width: 120, height: 150, fill: '#e5e7eb' },
                { type: 'text', left: 350, top: 160, text: 'NAME:', fontSize: 16, fill: '#666666', fontFamily: 'Arial' },
                { type: 'text', left: 350, top: 190, text: 'ALEXANDER SMITH', fontSize: 24, fontWeight: 'bold', fill: '#000000', fontFamily: 'Arial' },
                { type: 'text', left: 350, top: 240, text: 'GRADE:', fontSize: 16, fill: '#666666', fontFamily: 'Arial' },
                { type: 'text', left: 350, top: 270, text: '12TH GRADE', fontSize: 24, fontWeight: 'bold', fill: '#000000', fontFamily: 'Arial' }
            ]
        },
        {
            id: 6,
            name: 'Evento',
            icon: '🎫',
            color: 'bg-indigo-900',
            objects: [
                { type: 'rect', left: 0, top: 0, width: 640, height: 400, fill: '#4f46e5', selectable: false, evented: false },
                { type: 'circle', left: 580, top: -50, radius: 150, fill: '#818cf8', opacity: 0.5 },
                { type: 'circle', left: 50, top: 450, radius: 100, fill: '#818cf8', opacity: 0.5 },
                { type: 'text', left: 320, top: 60, text: 'TECH SUMMIT 2024', fontSize: 36, fontWeight: 'bold', fill: '#ffffff', fontFamily: 'Arial', originX: 'center' },
                { type: 'rect', left: 120, top: 140, width: 400, height: 160, fill: '#ffffff', rx: 10, ry: 10 },
                { type: 'text', left: 320, top: 180, text: 'SARAH CONNOR', fontSize: 32, fontWeight: 'bold', fill: '#1e1b4b', fontFamily: 'Arial', originX: 'center' },
                { type: 'text', left: 320, top: 230, text: 'KEYNOTE SPEAKER', fontSize: 20, fill: '#4f46e5', fontFamily: 'Arial', originX: 'center', fontWeight: 'bold' },
                { type: 'text', left: 320, top: 350, text: 'San Francisco, CA', fontSize: 16, fill: '#c7d2fe', fontFamily: 'Arial', originX: 'center' }
            ]
        },
    ];

    if (!isOpen) return null;

    const handleApply = () => {
        if (selectedTemplate) {
            const template = templates.find(t => t.id === selectedTemplate);
            if (onClose && template) {
                onClose(template.objects);
            }
            showSuccess(`Plantilla "${template.name}" aplicada.`);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-md flex items-center justify-center z-[9999] p-4 font-sans">
            <div className="bg-slate-900 rounded-2xl border border-slate-700 p-6 max-w-2xl w-full shadow-2xl max-h-[90vh] overflow-y-auto">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                        <span className="text-2xl mr-3">📋</span>
                        <h3 className="text-lg font-semibold text-white">Galería de Plantillas</h3>
                    </div>
                    <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
                    {templates.map((template) => (
                        <div
                            key={template.id}
                            onClick={() => setSelectedTemplate(template.id)}
                            className={`cursor-pointer rounded-xl border-2 p-4 transition-all hover:scale-105 ${selectedTemplate === template.id ? 'border-blue-500 bg-slate-800 shadow-lg shadow-blue-900/20' : 'border-slate-700 bg-slate-800/50 hover:border-slate-500'}`}
                        >
                            <div className={`h-24 rounded-lg mb-3 flex items-center justify-center text-4xl ${template.color} bg-opacity-50`}>
                                {template.icon}
                            </div>
                            <h4 className="text-white font-medium text-center">{template.name}</h4>
                        </div>
                    ))}
                </div>

                <div className="flex space-x-3">
                    <button onClick={onClose} className="flex-1 px-4 py-3 text-slate-300 border border-slate-600 rounded-xl hover:bg-slate-800 hover:text-white transition-colors">
                        Cancelar
                    </button>
                    <button
                        onClick={handleApply}
                        disabled={!selectedTemplate}
                        className="flex-1 px-4 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl hover:shadow-lg hover:shadow-blue-900/50 transition-all font-bold disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Aplicar Plantilla
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TemplateModal;
